export const getJourneyDetailsPath = (journey, journeyId = journey?.id ?? journey?._id) => (
  journey?.mainFlow === 'Conveyancer'
    ? `/conveyancing-journey-details/${journeyId}`
    : `/journey-details/${journeyId}`
);
